import { ItemMenu } from "../../../../components/baseMenu"

const formData: Record<string, string> = {
    divisions: 'division',
    stores: 'store',
    attentionType: 'byStoreSchedule',
    questionnaire: 'questionnaire',
    answersCount: 'items',
    userCreator: 'user',
    questionnaireDates: 'dateInitAnswer',
}

const menuItems: ItemMenu[] = [
    {
        label: 'Ver detalle',
        value: 1,
    },
    {
        label: 'Generar plan de acción',
        value: 2,
    },
    {
        label: 'Deshacer',
        value: 3,
    },
]

const formatFilter = {
    search: 'search',
    from: 'start_date',
    to: 'end_date',
    questionnaire: 'questionnaire_ids',
    question: 'question_ids',
    zone: 'zone_ids',
    userType: 'user_type_ids',
    user: 'user_ids',
    stores: 'store_ids',
    divisions: 'division_ids',
}

export { formData, formatFilter, menuItems }
